/*
 * Paleta de Cores Mexx - Clean & Professional
 * Integração com Material-UI usando a identidade Mexx
 */

const white = '#FFFFFF';
const black = '#212121';

// Cores Mexx
const mexxGreen = {
  primary: '#8BC34A',
  light: '#C8E6C9',
  dark: '#689F38',
  subtle: '#F1F8E9'
};

// Cinzas modernos
const mexxGray = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#EEEEEE',
  300: '#E0E0E0',
  400: '#BDBDBD',
  500: '#9E9E9E',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121'
};

export default {
  black,
  white,

  // Cores principais usando verde Mexx
  primary: {
    contrastText: white,
    dark: mexxGreen.dark,      // #689F38
    main: mexxGreen.primary,   // #8BC34A
    light: mexxGreen.light     // #C8E6C9
  },

  // Secundário usa tons de verde Mexx
  secondary: {
    contrastText: white,
    dark: mexxGreen.dark,
    main: mexxGreen.primary,
    light: mexxGreen.light
  },

  // Success usa o verde Mexx
  success: {
    contrastText: white,
    dark: mexxGreen.dark,
    main: mexxGreen.primary,
    light: mexxGreen.light
  },

  // Info em azul moderno
  info: {
    contrastText: white,
    dark: '#1976D2',
    main: '#2196F3',
    light: '#42A5F5'
  },

  // Warning em laranja
  warning: {
    contrastText: white,
    dark: '#F57C00',
    main: '#FF9800',
    light: '#FFB74D'
  },

  // Error em vermelho
  error: {
    contrastText: white,
    dark: '#D32F2F',
    main: '#F44336',
    light: '#EF5350'
  },

  // Sistema de texto usando cinzas modernos
  text: {
    primary: mexxGray[800],     // #424242
    secondary: mexxGray[600],   // #757575
    disabled: mexxGray[400],    // #BDBDBD
    title: mexxGray[900],       // #212121
    link: mexxGreen.primary     // #8BC34A
  },

  // Backgrounds limpos
  background: {
    default: white,             // #FFFFFF
    paper: white,               // #FFFFFF
    surface: mexxGray[50]       // #FAFAFA
  },

  // Ícones e elementos
  icon: mexxGray[600],          // #757575
  divider: mexxGray[300],       // #E0E0E0

  // Área administrativa (mantém funcionamento)
  admin: {
    contrastText: white,
    dark: mexxGray[600],
    main: mexxGray[500],
    light: mexxGray[400]
  },

  // Extensões Mexx específicas
  mexx: {
    green: mexxGreen,
    gray: mexxGray,

    // Status específicos
    status: {
      success: {
        main: mexxGreen.primary,
        background: mexxGreen.subtle
      },
      warning: {
        main: '#FF9800',
        background: '#FFF3E0'
      },
      error: {
        main: '#F44336',
        background: '#FFEBEE'
      },
      info: {
        main: '#2196F3',
        background: '#E3F2FD'
      },
      neutral: {
        main: mexxGray[500],
        background: mexxGray[100]
      }
    }
  }
};
